import { AuditedEntity } from "app/shared/model/app.model";
import { HREFTemplated, SelfCreatedUpdatedBy } from "app/shared/model/link.model";
import { HasId } from "app/shared/model/properties.model";
import { FileDetailType } from "ng/src/app/files/file-details/file-details.model";

export interface FileAttachment extends AuditedEntity, HasId {
    contentType?: string;
    description?: string;
    fileDate?: string;
    fileSize: number;
    filename: string;
    _links: SelfCreatedUpdatedBy & {
        data: HREFTemplated;
        log: HREFTemplated;
    }
}

export class FileAttachment {
	static isImage(fileAttachment: FileAttachment) {
		return !!fileAttachment.contentType?.startsWith('image');
	}

	// https://stackoverflow.com/a/18650828
	static humanReadableFileSize(byteSize: number, decimals = 2) {
		if (byteSize === 0)
			return '0 Bytes';

		const k = 1024,
			dm = decimals < 0 ? 0 : decimals,
			units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(byteSize) / Math.log(k));
	
		return parseFloat((byteSize / Math.pow(k, i)).toFixed(dm)) + ' ' + units[i];
	}
	
	static getHref(fa: FileAttachment) {
		return `/api/files/${fa.id}`;
	}
	
	static download(href: string): void;
	static download(fa: FileAttachment): void;
	static download(fa: FileAttachment | string): void {
		window.open(typeof fa === 'string' ? fa : this.getHref(fa), '_blank')
	}
}

export interface FileAttachmentRowData {
	description?: string;
	file: FileAttachment,
	extension: string;
	href: string;
	isImage: boolean;
	name: string;
	uploadedDate: string;
	id: number;
	type: FileDetailType.Type;
	canPlayMedia: boolean;
}

export class FileAttachmentRowData {
	public static fromFileAttachment(fa: FileAttachment): FileAttachmentRowData {
		return {
			id: fa.id,
			description: fa.description,
			extension: fa.filename.split('.').pop() || '',
			file: fa,
			href: FileAttachment.getHref(fa),
			isImage: FileAttachment.isImage(fa),
			name: fa.filename,
			uploadedDate: fa.created,
			canPlayMedia: FileDetailType.canPlayType(fa?.contentType ?? ''),
			type: FileDetailType.getType(fa?.contentType ?? '')
		};
	}

	public static fromFileAttachments(fileAttachments: FileAttachment[]) {
		return fileAttachments.map(this.fromFileAttachment)
	}
}